// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"Pw-z","smallCardRow":"Qw-z","largeCardRow":"Rw-z","productSearchRow":"Sw-z","curatedRow":"Tw-z"};